<template>
    <div>
      <app-header ref="navHeader"/>
      <el-scrollbar class="app_main" ref="appMain">
        <transition name="fade-transform" mode="out-in">
            <keep-alive :include="cachedViews">
                <router-view :key="key" />
            </keep-alive>
        </transition>
      </el-scrollbar>
      <app-footer/>
    </div>
</template>
<script>
import appHeader from './components/header.vue'
import appFooter from './components/footer.vue'
export default{
    name : 'flayout',
    components:{appHeader,appFooter},
    computed: {
      cachedViews() {
        return this.$store.state.tagsView.cachedViews
      },
      key() {
        return this.$route.path
      }
    }
}
</script>